<template>
<div class="chapter">
<div class="inner_page">
<p class="fmh" id="cre"><span class="epub-scb">THE</span> W<span class="epub-scb">HITE</span> H<span class="epub-scb">OUSE</span> D<span class="epub-scb">URING</span> L<span class="epub-scb">INCOLN’S</span> P<span class="epub-scb">RESIDENCY</span></p>
<p class="bnl"><span class="epub-b">1</span> Lincoln’s office connected by a private passageway to Family Living Room</p>
<p class="bnl"><span class="epub-b">2</span> Reception Room</p>
<p class="bnl"><span class="epub-b">3</span> Part of West Hall</p>
<p class="bnl"><span class="epub-b">4</span> Office stairs</p>
<p class="bnl"><span class="epub-b">5</span> Bedroom for Nicolay and Hay</p>
<p class="bnl"><span class="epub-b">6</span> Hay’s office</p>
<p class="bnl"><span class="epub-b">7</span> West Hall</p>
<p class="bnl"><span class="epub-b">8</span> Nicolay’s office</p>
<p class="bnl"><span class="epub-b">9</span> Family Living Room</p>
<p class="bnl"><span class="epub-b">10</span> Mary Lincoln’s bedroom</p>
<p class="bnl"><span class="epub-b">11-13</span> Lincoln’s bedroom/dressing room suite</p>
<p class="bnl"><span class="epub-b">14</span> Grand stairs and landing</p>
<p class="bnl"><span class="epub-b">15</span> Tad’s bedroom</p>
<p class="bnl"><span class="epub-b">16</span> Willie’s (Prince of Wales) bedroom</p>
<p class="bnl"><span class="epub-b">17</span> Service stairs</p>
<p class="bnl"><span class="epub-b">18-20</span> Pair of bedrooms divided by a corridor from whose window Lincoln spoke</p>
<p class="bnl"><span class="epub-b">21</span> Central Hall for family’s private living quarters</p>
<p class="page-break"> </p>
<p class="img"><img alt="image" height="593" src="images/pg8.jpg" width="400"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// credits.vue?7ca2e460